module.exports = __webpack_public_path__ + "img/img1.27c5b0bd.jpg";